import { camelizeObject } from '@cvt/helpers/object';

export const mapSpecializationData = (data: Specializations.SpecializationApi): Specializations.Specialization => {
  const specialization = camelizeObject<Specializations.Specialization>(data);
  return {
    ...specialization,
    careerOutlook: specialization.careerOutlook ? {
      ...specialization.careerOutlook,
      careerPaths: specialization.careerOutlook.careerPaths || [],
      employmentRate: (specialization.careerOutlook.employmentRate || 0) / 100,
    } : null,
  };
};
